import React from "react";
import "./speakers.css";
import doctor1 from "../../assets/images//doctors/Dr. Syed Moin Ali.jpg";
import doctor2 from "../../assets/images/doctors/Dr. Lisa Rucker.jpg";
import doctor3 from "../../assets/images/doctors/Dr. Abdul Bari.png";
import doctor4 from "../../assets/images/doctors/Dr. Adil Haider.png";
import doctor5 from "../../assets/images/doctors/Dr. Ahmed Yaqinuddin.jpeg";
import doctor6 from "../../assets/images/doctors/Dr. Ahmet Akin.jpeg";
import doctor7 from "../../assets/images/doctors/Dr. Ahsan Sethi.jpg";
import doctor8 from "../../assets/images/doctors/Dr. Ali.jpg";
import doctor9 from "../../assets/images/doctors/Dr. Eraky.jpeg";
import doctor10 from "../../assets/images/doctors/Dr. Faisal Sultan.jpeg";
import doctor11 from "../../assets/images/doctors/Dr. Manjit Kaur.jpg";
import doctor12 from "../../assets/images/doctors/Dr. Masood Jawaid.jpg";
import doctor13 from "../../assets/images/doctors/Dr. Mahmood Ayaz.jpeg";
import doctor14 from "../../assets/images/doctors/Dr. Muhammad Asif.jpeg";
import doctor15 from "../../assets/images/doctors/Dr. Rehan.jpeg";
import doctor16 from "../../assets/images/doctors/Dr. Renato Paro.jpg";
import doctor17 from "../../assets/images/doctors/Dr. Salman Kirmani.jpg";
import doctor18 from "../../assets/images/doctors/Dr. Vishna.jpg";
import doctor19 from "../../assets/images/doctors/Dr. Waseem Javaid.png";
import doctor20 from "../../assets/images/doctors/Dr. Zaraq Khan.jpeg";
import doctor21 from "../../assets/images/doctors/Mr. Shaukat Jawaid.jpeg";

const Speakers = () => {
  return (
    <div className="doctor-profiles">
      <div className="conference-image">
        <div className="heading-h2">
          <h1>Speakers</h1>
        </div>
      </div>
      <div className="profile-block">
        <div className="profile-text">
          <h3>
            Associate Professor, Head of HPE Dept., Director of MHPE & PhD in
            HPE programs, Gulf Medical University, UAE.
          </h3>
          <p>
            <span className="dr-name">Dr. Mohamed M. Al-Eraky,</span> is an
            Associate Professor and Director at Gulf Medical University, UAE,
            specializing in faculty development and medical professionalism.
            With a PhD in HPE from Maastricht University, he has led academic
            initiatives and contributed to top medical education journals. He
            developed influential models like the Four-Gates Model and Compass
            Model, widely used in postgraduate HPE programs. A global speaker,
            he has conducted workshops and presentations in over 10 countries.
          </p>
        </div>
        <div className="profile-image">
          <img src={doctor9} alt="Dr. Mohamed M. Al-Eraky" />
        </div>
      </div>

      <div className="profile-block reverse">
        <div className="profile-text">
          <h3>
            Professor of Anatomy and Cell Biology and Vice Dean of Graduate
            Studies and <br />
            Research at Alfaisal University, Saudi Arabia
          </h3>
          <p>
            <span className="dr-name">Dr. Ahmed Yaqinuddin,</span>
            With his extensive experience in medical education, curriculum
            development, and biomedical research, he has played a key role in
            advancing faculty development programs and innovative teaching
            methodologies. His research focuses on epigenetics in cancer and
            medical education, with numerous publications in high-impact
            journals. He has also secured significant research grants and
            contributed to international accreditation efforts. A dedicated
            educator and scientist, Dr. Yaqinuddin continues to shape the future
            of medical education and research.
          </p>
        </div>
        <div className="profile-image">
          <img src={doctor5} alt="Dr. Ahmed Yaqinuddin" />
        </div>
      </div>
      <div className="profile-block">
        <div className="profile-text">
          <h3>Faculty, Department of Educational Development, AKU, Pakistan</h3>
          <p>
            <span className="dr-name">Dr. Syed Moyn Aly,</span>is an expert in
            medical education and academic leadership. With an MHPE from
            Maastricht University and extensive experience in curriculum
            development, faculty training, and educational leadership, he has
            played a pivotal role in shaping medical education in Pakistan. He
            has previously held key positions at Dow University, CPSP, and Taif
            University, contributing to accreditation processes, faculty
            development, and postgraduate education. A prolific researcher with
            numerous publications, he is also actively involved in international
            medical education collaborations and accreditation bodies.
          </p>
        </div>
        <div className="profile-image">
          <img src={doctor1} alt="Dr. Mohamed M. Al-Eraky" />
        </div>
      </div>

      <div className="profile-block reverse">
        <div className="profile-text">
          <h3>
            Professor of Clinical Medicine, Albert Einstein College of Medicine,
            Bronx, NY
          </h3>
          <p>
            <span className="dr-name">Dr. Lisa Rucker,</span> is a Professor of
            Clinical Medicine at Albert Einstein College of Medicine and an
            Attending Physician at Jacobi Medical Center, Bronx, NY. With
            extensive experience in medical education, she has served as
            Co-Chief of the Division of General Medicine and Co-Director of the
            FMPC Clerkship. She has played a key role in curriculum development,
            faculty supervision, and mentoring MD/PhD students. A dedicated
            researcher and educator, she has received multiple awards,
            contributed to national medical education policies, and has been
            actively involved in professional organizations, research grants,
            and international presentations.
          </p>
        </div>
        <div className="profile-image">
          <img src={doctor2} alt="Dr. Lisa M. Rucker" />
        </div>
      </div>

      <div className="profile-block">
        <div className="profile-text">
          <h3>President, Indus Hospital & Health Network, Pakistan</h3>
          <p>
            <span className="dr-name">Dr. Abdul Bari Khan,</span> a cardiac
            surgeon and philanthropist, founded The Indus Hospital, Pakistan’s
            first free paperless hospital, which later expanded into the Indus
            Hospital & Health Network (IHHN). Under his leadership, IHHN has
            grown into one of Pakistan’s largest healthcare networks, managing
            13 hospitals across Sindh and Punjab. For his contributions to
            healthcare, he has received prestigious national honors, including
            the Tamgha-e-Imtiaz (2015) and Hilal-e-Imtiaz (2019).
          </p>
        </div>
        <div className="profile-image">
          <img src={doctor3} alt="Dr. Abdul Bari Khan" />
        </div>
      </div>

      <div className="profile-block reverse">
        <div className="profile-text">
          <h3>Dean, Medical College, AKU, Pakistan</h3>
          <p>
            <span className="dr-name">Dr. Adil H. Haider,</span> is the Dean of
            the Medical College at Aga Khan University (AKU) and a globally
            recognized trauma and acute care surgeon. An AKU alumnus, he earned
            his MPH from Johns Hopkins and trained in General Surgery, Surgical
            Critical Care, and Trauma Surgery. He has held prestigious positions
            at Johns Hopkins and Harvard, leading research in surgical outcomes
            and healthcare disparities. In Pakistan, he chairs the National
            Medical and Dental Academic Board and serves on the Prime Minister’s
            National Task Force on Health.
          </p>
        </div>
        <div className="profile-image">
          <img src={doctor4} alt="Dr. Adil H. Haider" />
        </div>
      </div>

      <div className="profile-block">
        <div className="profile-text">
          <h3>
            Professor, Izmir University of Economics, Medical Point Hospital,{" "}
            <br />
            Department of Obstetrics and Gynecology – İzmir, Turkey.
          </h3>
          <p>
            <span className="dr-name">Prof. Dr. Ahmet Akin Sivaslioglu,</span>{" "}
            is a leading expert in urogynecology and pelvic surgery, currently
            serving at Department of Obstetrics and Gynecology – İzmir, Turkey.
            He pioneered new surgical techniques, including the Sivaslioglu
            Thread Lift, and has significantly contributed to the field with
            widely cited research on pelvic floor disorders. He has authored key
            textbooks, including Practical Urogynecology, and has published
            extensively in national and international journals. A former
            president of the Urogynecology Association and the International
            Pelviperineology Society (ISPP), he actively leads educational
            workshops and congresses worldwide.
          </p>
        </div>
        <div className="profile-image">
          <img src={doctor6} alt="Prof. Dr. Ahmet Akin Sivaslioglu" />
        </div>
      </div>
      <div className="profile-block reverse">
        <div className="profile-text">
          <h3>
            Associate Professor, Program Lead, Chair RNG Health Professions
            Education,
            <br /> QU Health, Qatar University, Doha, Qatar
          </h3>
          <p>
            <span className="dr-name">Dr. Ahsan Sethi,</span> PhD, is an
            Associate Professor and Program Lead in Health Professions Education
            at Qatar University. A specialist in curriculum, assessment, and
            faculty development, he has led medical education reforms in
            Pakistan and Qatar. With over 70 publications and multiple
            fellowships, he actively contributes to research and policy
            development while serving as an associate editor for medical
            education journals.
          </p>
        </div>
        <div className="profile-image">
          <img src={doctor7} alt="Dr. Ahsan Sethi" />
        </div>
      </div>
      <div className="profile-block">
        <div className="profile-text">
          <h3>
            Senior Group Leader, Head, Laboratory of Translational Research in
            Neuropsychiatric Disorders, Poland
          </h3>
          <p>
            <span className="dr-name">Dr. Ali Jawaid,</span> is a neuroscientist
            and medical doctor with dual PhDs from the UZH MD-PhD program and
            ETH-UZH International Program in Neuroscience. With research
            spanning four countries, he specializes in neuroepigenetics,
            neuropsychiatry, and clinical research. He has authored 75+
            publications in top-tier journals and serves on advisory and
            editorial boards. A TEDx speaker, author, and poet, he is also the
            Co-founder, CEO, and CRO of BRAINALITY, a startup at the
            intersection of neuroscience and human-computer interaction.
          </p>
        </div>
        <div className="profile-image">
          <img src={doctor8} alt="Dr. Ali Jawaid" />
        </div>
      </div>
      <div className="profile-block reverse">
        <div className="profile-text">
          <h3>CEO, Shaukat Khanum Memorial Cancer Hospital, Pakistan</h3>
          <p>
            <span className="dr-name">Dr. Faisal Sultan,</span> is a renowned
            infectious diseases physician and the CEO of Shaukat Khanum Memorial
            Cancer Hospital & Research Centres in Pakistan. He previously served
            as the Special Assistant to the Prime Minister on National Health
            Services during the COVID-19 pandemic. A graduate of King Edward
            Medical College, he trained in internal medicine and infectious
            diseases in the U.S. and is certified by the American Board of
            Internal Medicine. Dr. Sultan has played key roles in national and
            global health initiatives, serving on advisory committees,
            accreditation bodies, and organizations like WHO and GAVI.
          </p>
        </div>
        <div className="profile-image">
          <img src={doctor10} alt="Dr. Faisal Sultan" />
        </div>
      </div>
      <div className="profile-block">
        <div className="profile-text">
          <h3>
            Senior Lecturer/Program Coordinator Bachelor of Nursing, <br />{" "}
            Faulty of Nursing, University of Cyberjaya, Malaysia
          </h3>
          <p>
            <span className="dr-name">Dr. Manjit Kaur Khaira,</span> is a Senior
            Lecturer and Program Coordinator for the Bachelor of Nursing at the
            University of Cyberjaya, Malaysia. With extensive clinical and
            academic experience, she has served in various healthcare and
            educational institutions, including Asia Metropolitan University and
            multiple medical centers. She holds a PhD in Community Health from
            Universiti Kebangsaan Malaysia and an MSc in Nursing from the
            University of Northumbria, UK. Dr. Khaira has published in
            peer-reviewed journals, presented at international conferences, and
            actively contributes to nursing education, research, and faculty
            development. Her expertise includes test anxiety among nursing
            students, public health, and integrating AI in nursing education.
          </p>
        </div>
        <div className="profile-image">
          <img src={doctor11} alt="Dr. Manjit Kaur Khaira" />
        </div>
      </div>
      <div className="profile-block reverse">
        <div className="profile-text">
          <h3>
            Director Medical Affairs & eLearning, PharmEvo, Associate Editor,
            Pakistan Journal of Medical Sciences, Pakistan
          </h3>
          <p>
            <span className="dr-name">Dr. Masood Jawaid,</span> is a General
            Surgeon, Medical Educationist, and Director of Medical Affairs at
            PharmEvo. He is an Associate Editor of Pakistan Journal of Medical
            Sciences and a visiting faculty member at multiple universities.
            With over 100 publications and two books, he specializes in medical
            research, digital education, and online learning. He has developed
            various e-learning courses and facilitated 300+ workshops globally
            on research, medical writing, and surgical training. His key
            interests include clinical education, Cognitive Load Theory, and
            distance learning innovations.
          </p>
        </div>
        <div className="profile-image">
          <img src={doctor12} alt="Dr. Masood Jawaid" />
        </div>
      </div>
      <div className="profile-block">
        <div className="profile-text">
          <h3>Vice Chancellor, Kind Edward Medical College, Pakistan</h3>
          <p>
            <span className="dr-name">Prof. Mahmood Ayyaz,</span> is the Vice
            Chancellor of King Edward Medical University, Lahore, and a
            distinguished surgeon and medical educator. A graduate of Allama
            Iqbal Medical College, he completed his fellowship in surgery in
            1990 and has since held key academic and administrative roles,
            including Chairman of Surgery at SIMS and Principal of Services
            Institute of Medical Sciences. With over 100 research publications,
            he has contributed significantly to medical education in Pakistan.
            He has also served as Director General of Punjab Human Organ
            Transplantation Authority, Vice President of CPSP (2020), and is the
            Director General of the National Residency Program at CPSP.
          </p>
        </div>
        <div className="profile-image">
          <img src={doctor13} alt="Prof. Mahmood Ayyaz" />
        </div>
      </div>
      <div className="profile-block reverse">
        <div className="profile-text">
          <h3>
            Dr. Muhammad Asif, Assistant Professor, Microbiology at Government
            College University,
            <br />
            Lahore, Pakistan
          </h3>
          <p>
            <span className="dr-name">Dr. Muhammad Asif,</span> holds expertise
            in microbiology, molecular genetics, and medical lab technology. He
            holds a PhD from the University of the Punjab and has extensive
            experience in teaching, research, and lab management. His research
            focuses on bacteriophage therapy, antimicrobial resistance, and
            molecular diagnostics, with numerous publications in high-impact
            journals. He has led multiple funded research projects and has
            received awards for his contributions to microbiology. Additionally,
            he serves as a consultant, trainer, and keynote speaker in national
            and international scientific forums.
          </p>
        </div>
        <div className="profile-image">
          <img src={doctor14} alt="Dr. Muhammad Asif" />
        </div>
      </div>
      <div className="profile-block">
        <div className="profile-text">
          <h3>
            Dean, Riphah Institute of Assessment & HOD & Prof. of Surgery,
            Pakistan
          </h3>
          <p>
            <span className="dr-name">Prof. Rehan Ahmed Khan,</span> is the Dean
            of Assessment, HOD & Professor of Surgery, and Director of the
            Department of Medical Education. He is also the Vice President of
            ICME and Editor-in-Chief of Health Professions Educator Journal. As
            a facilitator at CPSP and visiting faculty at KMU and UOL, he
            actively contributes to medical education. His goal is to
            revolutionize medical education in Pakistan, aligning it with global
            standards to produce competent doctors for both local and
            international healthcare needs. His expertise includes general and
            laparoscopic surgery, curricular development, and assessment in
            medical education.
          </p>
        </div>
        <div className="profile-image">
          <img src={doctor15} alt="Prof. Rehan Ahmed Khan" />
        </div>
      </div>
      <div className="profile-block reverse">
        <div className="profile-text">
          <h3>
            Professor Emeritus at the Department of Biosystems Science and
            Engineering, Switzerland
          </h3>
          <p>
            <span className="dr-name">Prof. Renato Paro,</span> PhD, is a
            molecular biologist who studied at the Biozentrum, University of
            Basel. After postdoctoral research at Edinburgh and Stanford, he
            built his career at ZMBH, Heidelberg, where he became Director
            (2001–2004). In 2006, he became the Founding Director of the Center
            of Biosystems Science and Engineering at ETH Zurich and a Professor
            at the University of Basel. He later chaired ETH Zurich’s Department
            of Biosystems Science and Engineering. He is a citizen of
            Birsfelden, Switzerland.
          </p>
        </div>
        <div className="profile-image">
          <img src={doctor16} alt="Prof. Renato Paro" />
        </div>
      </div>
      <div className="profile-block">
        <div className="profile-text">
          <h3>
            Chair, Division of Women & Child Health, Aga Khan University,
            Karachi, Pakistan
          </h3>
          <p>
            <span className="dr-name">Dr. Salman Kirmani</span> is a Medical
            Geneticist and Pediatric Endocrinologist, serving as Professor and
            Chair of the Division of Women & Child Health at Aga Khan
            University. A graduate of Dow Medical College, he completed his
            residency and fellowships at Mayo Clinic, where he was also on
            faculty before returning to Pakistan in 2014. He has authored over
            65 publications and led pioneering genetic clinics at AKU, including
            Pediatric Genetics and Hereditary Cancer Clinics. Actively involved
            in research, advocacy, and education, he supports parent groups for
            rare genetic disorders and works to advance Precision Medicine in
            Pakistan.
          </p>
        </div>
        <div className="profile-image">
          <img src={doctor17} alt="Dr. Salman Kirmani" />
        </div>
      </div>
      <div className="profile-block reverse">
        <div className="profile-text">
          <h3>CEO, Provost and Professor of Medical Education, Malaysia</h3>
          <p>
            <span className="dr-name">Vishna Devi V Nadarajah</span> is a
            distinguished leader in health professions education, serving as CEO
            and Provost at Newcastle University Medicine Malaysia. With over 15
            years of leadership experience, she specializes in faculty
            development, assessments, and innovative teaching. She holds a PhD
            from Cambridge and an MHPE from Maastricht. A recognized researcher
            and mentor, she has received prestigious awards, including the ASME
            Gold Medal (2023) and Ian Hart Award (2024). She is also a trustee
            of AMEE and an advisory board member of IAMSE.
          </p>
        </div>
        <div className="profile-image">
          <img src={doctor18} alt="Vishna Devi V Nadarajah" />
        </div>
      </div>
      <div className="profile-block">
        <div className="profile-text">
          <h3>
            Project Director, SEHAT MEDICAL COMPLEXES, Director Rehabilitation,
            <br /> University of Lahore Teaching Hospital, UOL, Pakistan
          </h3>
          <p>
            <span className="dr-name">Dr. Waseem Javaid</span> is a
            physiotherapy expert and academic leader, currently serving as
            Project Director of SEHAT Medical Complexes, Director of Clinical
            Services at the Faculty of Allied Health Sciences, and Director of
            Rehabilitation at the University of Lahore Teaching Hospital. He
            holds a PhD in Rehabilitation Sciences from Riphah International
            University and has extensive experience in musculoskeletal
            physiotherapy, manual therapy, and rehabilitation. With
            international training in advanced physiotherapy techniques, he has
            published multiple research papers and serves as Editor-in-Chief of
            the Journal of Rehabilitation and Clinical Research.
          </p>
        </div>
        <div className="profile-image">
          <img src={doctor19} alt="Dr. Waseem Javaid" />
        </div>
      </div>
      <div className="profile-block reverse">
        <div className="profile-text">
          <h3>
            Dr. Zarak Khan Associate Professor of Obstetrics and Gynecology,
            Mayo Clinic, USA
          </h3>
          <p>
            <span>Dr. Zaraq Khan,</span> is a Consultant and Chair of the
            Division of Reproductive Endocrinology and Infertility at Mayo
            Clinic, where he also serves as an Associate Professor of Obstetrics
            and Gynecology. His research focuses on patient outcomes after
            gynecologic surgeries, including hysterectomy, endometriosis, and
            fibroid surgery, as well as fertility preservation through ovarian
            tissue cryopreservation and uterine transplantation. With advanced
            training in reproductive endocrinology, clinical research, and
            translational science, Dr. Khan contributes to improving fertility
            treatments and reproductive health care for women.
          </p>
        </div>
        <div className="profile-image">
          <img src={doctor20} alt="Dr. Zaraq Khan" />
        </div>
      </div>
      <div className="profile-block">
        <div className="profile-text">
          <h3>
            Chief Editor, Pulse International & Pakistan Journal of Medical
            Sciences, Pakistan
          </h3>
          <p>
            <span className="dr-name">Shaukat Ali Jawaid</span> is a seasoned
            medical journalist and editor with extensive experience in
            Pakistan's healthcare media landscape. He serves as the Chief Editor
            of Pakistan Journal of Medical Sciences and Pulse International,
            contributing significantly to medical journalism and literature. As
            Secretary General of the Eastern Mediterranean Association of
            Medical Editors (EMAME), he plays a pivotal role in promoting
            medical editing standards in the region. Mr. Jawaid is also a member
            of the Pakistan Medical Commission and the National Bioethics
            Committee, reflecting his commitment to upholding ethical standards
            in medical practice and research. His dedication to medical
            journalism and ethics has established him as a respected figure in
            Pakistan's medical community.
          </p>
        </div>
        <div className="profile-image">
          <img src={doctor21} alt="Shaukat Ali Jawaid" />
        </div>
      </div>
    </div>
  );
};

export default Speakers;
